import Link from 'next/link'
import Logo from '@/components/Shared/Logo'
import styles from './styles.module.scss'

export default function HeaderLogo() {
  return (
    <div className={styles.headerLogoArea}>
      <Link href='/' className={styles.brand}>
        <Logo />
      </Link>
    </div>
  )
}
